<template>
  <div>
    <PageTitle
      :main="$t('configuracao') + `${title}`"
      sub=""
      imagem="dashboard.png"
    />
    <div>
      <b-tabs class="indicator-configurator">
        <b-tab :title="$t('peso-dos-indicadores')" @click="title=$t('peso-dos-indicadores')" active>
          <GridWeightIndicator :role="role"></GridWeightIndicator>
        </b-tab>
        <b-tab :title="$t('relacionamento-dos-indicadores')" @click="title=$t('relacionamento-dos-indicadores')">
            <relational-indicator> </relational-indicator>
        </b-tab>
      </b-tabs>
    </div>
    
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import GridWeightIndicator from "./GridWeightIndicator";
import RelationalIndicator from './RelationalIndicator.vue';

export default {
  name: "WeightIndicator",
  components: { GridWeightIndicator, PageTitle, RelationalIndicator },
  data() {
    return {
      role: this.$route.params.role,
      imagem: "",
      title:this.$t('peso-dos-indicadores'),
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.role = to.params.role;
    },
  },
};
</script>

<style scoped>
img {
  max-height: 45px;
}
</style>

<style>

.indicator-configurator ul{
  margin: 0 8px 4px;
}

.indicator-configurator a{
  height: 3vh;
  padding: 0 8px;
  color: #0007;
  font-weight: 500;
}

</style>
